export default "__VITE_ASSET__3c505271__"